module.exports = __webpack_public_path__ + "media/images/sp/specials/okinawa_churaumi_aquarium/plan_included_data-4d4524b809e151af11b51d2e2a32a3ba.png";